import { render, staticRenderFns } from "./customer_apply.vue?vue&type=template&id=597f8184&scoped=true&"
import script from "./customer_apply.vue?vue&type=script&lang=js&"
export * from "./customer_apply.vue?vue&type=script&lang=js&"
import style0 from "./customer_apply.vue?vue&type=style&index=0&id=597f8184&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597f8184",
  null
  
)

export default component.exports